import { Form, Input } from 'antd';
import React, { FC } from 'react';
import style from './index.module.scss';

type TProps = {
  name: string;
  placeholder: string;
  onSearch: (data: string) => void;
};

const StringFormItem: FC<TProps> = ({ onSearch, name, placeholder }) => {
  return (
    <Form.Item name={name} className={style.searchInput}>
      <Input.Search placeholder={placeholder} allowClear onSearch={onSearch} />
    </Form.Item>
  );
};

export default StringFormItem;
